import { Button, ButtonVariants, FormControlSizes, IconName } from '@talos/kyoko';
import type { MouseEvent } from 'react';

interface PrimeScenarioButtonProps {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export function PrimeScenarioButton({ onClick, disabled = false }: PrimeScenarioButtonProps) {
  return (
    <Button
      variant={ButtonVariants.Default}
      size={FormControlSizes.Small}
      onClick={onClick}
      disabled={disabled}
      startIcon={IconName.ArrowRight}
      data-testid="pre-trade-use-scenario"
    >
      Use Scenario
    </Button>
  );
}
